<template>
    <div class="h-screen bg-gray-200">

        <div class="flex flex-wrap w-full justify-center md:justify-between items-center
        py-3 bg-white shadow-lg">
            <div class="flex ml-0 md:ml-6 cursor-pointer pr-4 items-center" @click="goBack">
                <img alt="school logo" class="h-10 w-10" src="../../images/gciosa.png">
                <span class="ml-1 text-xl text-white text-blue-900 font-semibold invisible md:visible">GCIOSA</span>
            </div>

            <ul class="md:flex sm:block mt-6 md:mt-0 ml-6 md:ml-0 overflow-x-auto mr-0 md:mr-10 font-semibold pt-0 md:pt-2">

                <li class="mb-2 px-4 py-1 bg-white border-red-900 hover:bg-red-900 rounded-lg text-red-900 hover:text-white"
                    style="border-width: 1px">
                    <a @click="logout" class="text-sm">Logout</a>
                </li>

            </ul>
        </div>

        <div class="mx-auto px-4 md:px-12 pt-6">
            <span class="block w-full pt-1 text-xl font-semibold mb-4 tracking-wide border-orange-500" style="border-bottom-width: 1px">Gallery</span>

            <!-- loader -->
            <div v-if="loading" class="h-screen w-full">
                    <div class="flex h-screen items-center">
                    <vue-loaders
                        name="ball-spin-fade-loader"
                        color="#2a4365"
                        class="flex m-auto my-4"
                        scale="1"
                    ></vue-loaders>
                    </div>
                </div>

            <!-- add album button and album grid -->
            <div v-else>
                <button class="flex flex-row items-center px-3 py-2 text-white text-sm font-semibold bg-green-600
                hover:bg-green-900 rounded mb-4" @click="goToAddAlbum">
                    <plus-icon class="mr-1"/>
                    Add photo album
                </button>

                <div class="flex flex-wrap -mx-1 lg:-mx-2 bg-gray-200">



                    <!-- Column -->
                    <div  v-for="item in albums" :key="item.id" class="my-1 pr-2 w-full mb-6 md:w-1/3 md:mb-4 md:px-4">

                        <!-- Article -->
                        <article class="overflow-hidden rounded-md shadow-md mb-4 bg-white pb-4">

                            <!--                    <a href="#">-->
                            <!--                        <images alt="Placeholder" class="block h-56 w-full object-cover" :src="item.photos[0].photo_link">-->
                            <!--                    </a>-->
                            <slider v-if="item.photos.length  > 0" :photos="item.photos"></slider>
                            <img v-else alt="Placeholder" class="block h-56 w-full object-cover" src="../../images/loading.gif">

                            <!--                    <carousel :data="getCarouselData(item)" :controls="false" class="block h-56 w-full object-cover"></carousel>-->

                            <header class="flex items-center justify-between leading-tight p-2">
                                <h1 class="container text-base">
                                    <a class="flex-wrap no-underline hover:underline text-black">
                                        {{item.title}}
                                    </a>
                                </h1>

                            </header>

                            <footer class="flex items-center justify-between leading-none p-2">
                                <p class="text-grey-darker text-sm">
                                    {{item.created_at | formatDateSlash}}
                                </p>

                                
                                <button @click="goToAlbumView(item.id)"
                                        class="relative inline-block px-4 py-2 ml-2 rounded font-semibold text-blue-900 bg-blue-200
                                        hover:text-white hover:bg-blue-900 leading-tight shadow">
                                            <span aria-hidden
                                                class="absolute  opacity-50"></span>
                                    <span class="relative text-sm">View {{item.photos.length}} {{item.photos.length > 1 ? 'photos' : 'photo'}}</span>
                                </button>
                                <!--                        </a>-->
                                <!--                        <a class="no-underline text-grey-darker hover:text-red-dark" href="#">-->
                                <!--                            <span class="hidden">Like</span>-->
                                <!--                            <i class="fa fa-heart"></i>-->
                                <!--                        </a>-->
                            </footer>

                            <div class="flex flex-row justify-end my-2 mr-2">
                                <EditIcon style="color: blue" @click="goToAlbumEdit(item.id)"/>
                                <Trash2Icon class="text-red-600 ml-4" @click="deleteAlbum(item.id)" />
                            </div>

                        </article>
                        <!-- END Article -->

                    </div>
                    <!-- END Column -->


                </div>
            </div>

        </div>
    </div>

</template>

<style scoped>


</style>

<script>

    // import router from "../../../js/routes";
    import Axios from "axios";
    import slider from '../user/slider';
    import {PlusIcon, EditIcon, Trash2Icon} from 'vue-feather-icons';

    export default {
        name: "photo-gallery",
        components: {slider, PlusIcon, EditIcon, Trash2Icon},
        data: function () {
            return {
                loading: true,
                data: [],

                // link: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-1.jpg',
                //
                // album: [
                //     {
                //         id: 1, title: 'title1 hjgfjshgjhf jhakjhfjkf kjhfskjhfkj kjhdsfkjhkjfs kjhfksjhkj',
                //         img_src: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-1.jpg',
                //         date: '12/09/2020'
                //     },
                //
                //     {
                //         id: 1, title: 'title2',
                //         img_src: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-2.jpg',
                //         date: '12/09/2021'
                //     },
                //
                //     {
                //         id: 1, title: 'title3 ghjsgdjhbd cdjkdhkshckjds kjdskjhdkjchsc jhsckjhjshkjsc jhcksjhkjhcs kcskjjkcs jhcskjh',
                //         img_src: 'https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-3.jpg',
                //         date: '12/09/2022'
                //     },
                // ],

                albums: [],


        }
            ;
        },
        methods: {


            getAlbums:  function(){
                this.loading = true;
                let token = localStorage.getItem('token');
                if(token === null){
                    this.$router.push('/');
                    this.$swal('Please log in');
                }else{
                    Axios.get('/api/gallery',
                        {headers: {'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`}}
                    ).then(response => {
                        // console.log(response.data);
                        this.loading = false;
                        if(response.data.status){
                            this.albums = response.data.data;


                        }else{
                            this.$router.push('/');
                            this.$swal('Please log in');
                        }
                    });
                }

            },

            goToAlbumView(id){

                this.$router.push(`/gallery/${id}`)
            },

            logout: function(){
                localStorage.clear();
                this.$router.push('/');
            },

            goToAddAlbum: function(){
                this.$router.push('/admin/add_edit_album');
            },

            goToAlbumEdit: function(id){
                this.$router.push(`/admin/add_edit_album/${id}`)
            },

            deleteAlbum(id){
                this.$swal({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        let token = localStorage.getItem("token");
                        return Axios.delete(`/api/gallery/${id}`, {
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                            }
                        }).then(response => {
                            // this.$swal.stopLoading();
                            if (response.data.status === true) {
                            this.albums = response.data.data;
                            this.$swal("Deleted!", "Your Album has been deleted.", "success");
                            } else {
                            this.$swal("Please login");
                            this.$router.push("/");
                            }
                        });
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                    
                });
            },

            goBack(){
                this.$router.back();
            }


        },

        // computed: {
            // getCarouselData(photos){
            //     console.log(photos);
            //     let data = [];
            //     // photos.forEach((item, index) => {
            //     //     data.push(`<images alt="Placeholder" class="block h-56 w-full object-cover" src=${item.photo_link}>`);
            //     //     console.log(`<images alt="Placeholder" class="block h-56 w-full object-cover" src=${item.photo_link}>`);
            //     // });
            //
            //     return data;
            // }
        // },


        created() {
            this.getAlbums();
        }


    }
</script>
